/**
 * 合同模板接口文档
 */
import {
    Method,
    Mode
  } from '../core';
  import {
    API,
    LOCAL,
    SOURCE
  } from '../config';
  
  const api = API;
  const local = LOCAL;

  
  export default {
    // 获取文档信息
    getDoc: {
      url: `${api}/rest/v1/template/findById`,
      method: Method.GET,
      body: {
        templateId: {
          $type: String,
          $required: true
        },
        source: {
          $type: String,
          $default: SOURCE
        }
      }
    },
    // 更新模板
    updateDoc: {
      url: `${api}/rest/v1/template/update`,
      method: Method.POST,
      body: {
        templateId: {
          $type: String,
          $required: true
        },
        templateName: {
          $type: String,
          $required: true
        },
        font: {
          $type: String,
          $required: true
        },
        fontSize: {
          $type: Number,
          $required: true
        },
        fieldDataList: {
          $type: Array,
          $required: true
        },
        source: {
          $type: String,
          $default: SOURCE
        }
      }
    },
    // 更新模板
    geneDoc: {
      url: `${api}/rest/v1/template/generatePdf`,
      method: Method.POST,
      body: {
        templateId: {
          $type: String,
          $required: true
        },
        fieldDataList: {
          $type: Array,
          $required: true
        },
        docName: {
          $type: String,
          $required: false
        },
        source: {
          $type: String,
          $default: SOURCE
        }
      }
    },
    // 获取填写内容
    getInputData: {
      url: `${api}/rest/v1/template/getInputData`,
      method: Method.GET,
      body: {
        templateId: {
          $type: String,
          $required: true
        },
        inputDataId: {
          $type: String,
          $required: false
        },
        source: {
          $type: String,
          $default: SOURCE
        }
      }
    },
    // 发起签署上传
    uploadTemp: {
      url: `${api}/rest/v1/file/upload/osskey`,
      method: Method.POST,
      body: {
        keyList: {
          $type: Array,
          $required: true
        },
        docName: {
          $type: String,
          $required: true
        },
        flowType: {
          $type: Number,
          $required: true
        },
        source: {
          $type: String,
          $default: SOURCE
        }
      }
    }
  };
  


// WEBPACK FOOTER //
// ./src/resource-api/api/template.js